import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../shared/shared.module';
import { NgPipesModule } from 'ngx-pipes';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { EventLogComponent } from './event-log.component';
import { EventLogTableComponent } from './event-log-table.component';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { PaginationModule } from 'ngx-bootstrap/pagination';

@NgModule({
  declarations: [
    EventLogTableComponent,
    EventLogComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    NgPipesModule,
    PaginationModule.forRoot(),
    TabsModule.forRoot(),
    BsDropdownModule.forRoot()
  ],
  exports: [
    EventLogTableComponent,
    EventLogComponent,
  ]
})
export class EventLogModule {}
